import cn from "classnames";

import styles from "./small-loader.module.scss";

type SmallLoaderTypes = "DARK" | "LIGHT" | "ORANGE";

interface SmallLoaderTypesInterface {
  type: SmallLoaderTypes;
}

const SmallLoader = ({ type }: SmallLoaderTypesInterface) => (
  <div
    className={cn(
      { [styles["loader"]]: type === "DARK" },
      { [styles["loader--light"]]: type === "LIGHT" },
      { [styles["loader--orange"]]: type === "ORANGE" }
    )}
  ></div>
);

export default SmallLoader;
